__webpack_require__.p = "https://static.age.awaze.com/search-mfe/dd94cd9/_next/";